import React, {
  createContext,
  PropsWithChildren,
  useRef,
  useState,
} from 'react';
import { ProfileCardViewType } from '@/components/@IntranetLibrary/ProfileCard';
import ProfileCardModal from '@/components/@IntranetLibrary/ProfileCard/ProfileCardModal';
import { ModalRef } from '@/components/@IntranetLibrary/Modal';
import useModal from '@/hooks/useModal';

type ProfileCardModalContextProps = {
  open: (passportId: string, isSaveHistory: boolean) => void;
  close: () => void;
};
const ProfileCardModalContext =
  createContext<ProfileCardModalContextProps | null>(null);
ProfileCardModalContext.displayName = 'ProfileCardModal';

const ProfileCardModalProvider = ({ children }: PropsWithChildren) => {
  const userProfileModal = useRef<ModalRef>(null);
  const { openModal, closeModal } = useModal(userProfileModal);

  const [isSave, setIsSave] = useState(false);

  const open = (passportId: string, isSave: boolean) => {
    setIsSave(isSave);
    openModal(passportId);
  };

  const close = () => {
    closeModal();
  };

  return (
    <ProfileCardModalContext.Provider value={{ open, close }}>
      {children}
      <ProfileCardModal
        ref={userProfileModal}
        view={ProfileCardViewType.BADGE}
        saveSearchData={isSave}
      />
    </ProfileCardModalContext.Provider>
  );
};

export { ProfileCardModalProvider, ProfileCardModalContext };
